var footer_element = jQuery('body.home footer.content-info');
var header_element = jQuery('body.home section.home-banner-slider');
var section_after_header = jQuery('body.home section.count-row');

var footer_height = footer_element.outerHeight();
var header_height = header_element.outerHeight();

var top_of_screen = jQuery(window).scrollTop();
var height_of_screen = jQuery('body').outerHeight();
var window_height = jQuery(window).outerHeight();

/*adjust as per design */
var variable_margin = -300;
var last_margin_top = -(variable_margin);

var second_section_after_header = jQuery('body.home section.card-slider-wrapper');

var complete_content_section = jQuery('body.home div.container-full');
var section_height = jQuery('body.home section.count-row').outerHeight();
var menu_element = jQuery('header');

var checkWinHeight = parseInt(window_height / 7);
var last_scroll;
var fixed = false;
var minusTop = 1;

function checkViewport() {
    var viewport = viewportWidhOnLoad();

    if (viewport.width > 768 && jQuery('body').hasClass('home')) {
        return true;
    } else {
        return false;
    }
}

function makeHeaderFooterSticky() {
    top_of_screen = jQuery(window).scrollTop();
    height_of_screen = jQuery('body').outerHeight();
    window_height = jQuery(window).outerHeight();

    section_height = jQuery('body.home section.count-row').outerHeight();


    /* Header*/
    /*	if (top_of_screen > checkWinHeight) {
     var headerTop = parseInt(window_height/7) + top_of_screen+variable_margin;
     if (headerTop > 0) {
     header_element.css('top', -(headerTop));

     }
     } else {
     last_scroll = top_of_screen;
     last_margin_top = (window_height - top_of_screen + variable_margin);

     if (top_of_screen>=0) {
     section_after_header.css('margin-top', last_margin_top);
     second_section_after_header.css('margin-top', variable_margin - section_height);
     } else {

     section_after_header.css('margin-top', variable_margin);
     second_section_after_header.css('margin-top', 0);

     }
     header_element.css('top',0);
     }*/

    /* Footer*/
    if (top_of_screen >= (height_of_screen - footer_height - window_height + variable_margin)) {
        footer_element.css('position', 'fixed');
        //section_after_header.css('margin-bottom', footer_height);
    } else {
        footer_element.css('position', 'relative');
        //section_after_header.css('margin-bottom',footer_height);
    }
}
jQuery(document).ready(function () {
    if (checkViewport()) {
        /*	header_element.css('opacity',0);
         header_height = header_element.outerHeight();
         section_height = jQuery('body.home section.count-row').outerHeight();
         height_of_screen = jQuery('body').outerHeight();
         top_of_screen = jQuery(window).scrollTop();*/

        /*adjust as per design */
        /*header_height = header_height + variable_margin;

         if (top_of_screen === 0) {
         section_after_header.css('margin-top', header_height);
         second_section_after_header.css('margin-top',0);
         } else if(top_of_screen >= checkWinHeight){
         section_after_header.css('margin-top', header_height - checkWinHeight);
         second_section_after_header.css('margin-top', variable_margin - section_height);
         } else {
         section_after_header.css('margin-top', variable_margin);
         second_section_after_header.css('margin-top', variable_margin - section_height);
         }*/

        section_after_header.css('opacity', 1);
        second_section_after_header.css('opacity', 1);
        header_element.css('opacity', 1);

        footer_height = footer_element.outerHeight();

        complete_content_section.css('margin-bottom', footer_height);
        // makeHeaderFooterSticky();
    } else {
        complete_content_section.css('margin-bottom', 0);
    }
});

jQuery(window).scroll(function () {
    if (checkViewport()) {
        makeHeaderFooterSticky();
    }
});

jQuery(window).resize(function () {
    if (!checkViewport()) {
        /*header_height = header_element.outerHeight();
         header_height = header_height + variable_margin;
         section_after_header.css('margin-top', header_height);
         second_section_after_header.css('margin-top',0);*/
        /*footer_element.css('position','relative');*/
        complete_content_section.css('margin-bottom', 0);
    } else {
        /*footer_element.css('position','fixed');*/
        footer_height = footer_element.outerHeight();

        complete_content_section.css('margin-bottom', footer_height);
    }
});


jQuery(document).on('nfFormReady', function (e, layoutView) {
    if (checkViewport()) {
        footer_height = footer_element.outerHeight();
        complete_content_section.css('margin-bottom', footer_height);
    } else {
        complete_content_section.css('margin-bottom', 0);
    }
});

